import type { MultipleFlavorsSelectorItem } from "@ui/components/MultipleFlavorsSelector";

export type BrandWithFlavorItems = {
  brandId: string;
  brandLabel: string;
  brandIconUrl?: string;
  items: MultipleFlavorsSelectorItem[];
};
